import { useLocale } from "../hooks/useLocale";
import { msg } from "../locales/translate";
import { GD } from "../GD";
import { Box, HBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import Spacer from "@ui/spacer/Spacer";
import { Typo } from "@ui/text/Typo";
import { ProjectsView } from "./ProjectsView";
import { useMobile } from "src/hooks/useMobile";
import { StartScreenView } from "./StartScreenView";

export const SelectProjectView = () => {
	useLocale();
	const { isMobile, isTablet } = useMobile();
	return (
		<StartScreenView>
			<Box
				sx={{
					width: isMobile ? "100%" : undefined,
					overflow: isMobile ? "auto" : undefined,
					display: "flex",
					height: "100%",
					minHeight: isMobile ? undefined : "700px",
					borderStartStartRadius: isMobile ? "0" : "12px",
					borderEndStartRadius: isMobile ? "0" : "12px",
					borderEndEndRadius: isTablet ? "12px" : "0",
					borderStartEndRadius: isTablet ? "12px" : "0",
					backgroundColor: "rgba(255,255,255,1)",
				}}>
				<Box
					sx={{
						padding: isMobile ? "34px 26px" : "60px",
						minWidth: isMobile ? "0" : "500px",
						width: isMobile ? "100%" : "auto",
						display: "flex",
						margin: isMobile ? "auto" : undefined,
						maxWidth: isMobile ? "500px" : undefined,
						flexDirection: "column",
					}}>
					<Typo capitalize sx={{ fontSize: "26px", fontWeight: 400 }}>{msg("projects")}<br />{msg("selectProject")}<br />{msg("toAdministrate")}</Typo>
					<Spacer size="40px" />
					<ProjectsView tiny />
					<Spacer size="40px" />
					<HBox>
						<Spacer grow />
						<Button variant="secondary" onClick={() => GD.S_AUTH_LOG_OUT.invoke()}>{msg("logOut")}</Button>
					</HBox>
				</Box>
			</Box>
		</StartScreenView>
	);
};
